// src/components/Modal/Modal.jsx
import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import './Modal.css'

const Modal = ({ open, onClose, children, ariaLabel = 'Enquiry form' }) => {
  useEffect(() => {
    if (!open) return;

    const prevOverflow = document.body.style.overflow;
    const prevPaddingRight = document.body.style.paddingRight;
    const scrollbarW = window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = 'hidden'; // lock scroll
    if (scrollbarW > 0) document.body.style.paddingRight = `${scrollbarW}px`;

    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);

    // Optional: focus first field in the form after mount
    setTimeout(() => {
      const first = document.querySelector('.modal-panel input, .modal-panel select, .modal-panel button');
      first?.focus();
    }, 0);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.paddingRight = prevPaddingRight;
      document.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="modal-root">
      <div className="modal-backdrop" onClick={onClose} aria-hidden="true" />
      <div
        className="modal-panel"
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
      >
        <button className="modal-close" onClick={onClose} aria-label="Close form">
          ×
        </button>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
